export default "__VITE_ASSET__de809622__"